import { render, staticRenderFns } from "./clinic-demo-data-uploader.vue?vue&type=template&id=586c1fdf&scoped=true"
import script from "./clinic-demo-data-uploader.vue?vue&type=script&lang=js"
export * from "./clinic-demo-data-uploader.vue?vue&type=script&lang=js"
import style0 from "./clinic-demo-data-uploader.vue?vue&type=style&index=0&id=586c1fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586c1fdf",
  null
  
)

export default component.exports